import { DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  NgZone,
  OnInit,
  Optional,
  OnDestroy,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  Input,
} from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'form-select-dropdown-panel',
  templateUrl: './select-dropdown-panel.component.html',
})
export class SelectDropdownPanelComponent implements OnInit, OnDestroy {


  @Output() outsideClick = new EventEmitter<void>();
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private _zone: NgZone,
    @Optional() @Inject(DOCUMENT) private _document: any,
    private eRef: ElementRef

  ) { }

  ngOnInit() {
    // this._handleOutsideClick();
  }


  @HostListener('document:click', ['$event'])
  clickout(event) {
    console.log(event.target);
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit();
    }
  }


  // private _handleOutsideClick() {
  //   if (!this._document) {
  //     return;
  //   }
  //   this._zone.runOutsideAngular(() => {
  //     merge(
  //       fromEvent(this._document, 'touchstart', { capture: true }),
  //       fromEvent(this._document, 'mousedown', { capture: true })
  //     ).pipe(takeUntil(this._destroy$))
  //       .subscribe($event => this.outsideClick.emit());
  //   });
  // }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._destroy$.unsubscribe();
  }
}
